export const PATIENT_TIMELINE_FIRST_PAGE_SIZE = 5;
export const PATIENT_TIMELINE_OLDER_PAGE_SIZE = 20;
